<template>
  <div>
    <h3>审批产品信息</h3>
    <div v-for="(item, index) in listForm" :key="index" class="outside-box">
      <div class="bill-box">
        <div class="bill-label">寻样单信息:</div>
        <ApplySample
          ref="sampleDialog"
          :isDisabled="true"
          :isDemandBrand="true"
          :isInput="false"
          :listData="item"
        />
      </div>
      <div class="bill-box">
        <div class="bill-label">审批意见:</div>
        <el-form
          ref="confirmInfoForm"
          style="width: 100%; margin-left: -45px;"
          :model="item.list[0]"
          label-width="100px"
          size="mini"
          inline
          :rules="rules"
        >
          <el-form-item label="审批结果" prop="leaderStatus">
            <DictSelect
              type="cml_sample_checkstatus"
              :value="item.list[0].leaderStatus"
              @change-emit="checkStatusChange($event, index)"
            />
          </el-form-item>
          <span v-if="item.list[0].leaderStatus === 'NO_PASS'">
            <el-form-item label="理由" prop="leadApprovalOpinion">
              <el-input
                style="width: 300px"
                type="textarea"
                placeholder="请输入内容"
                v-model="item.list[0].leadApprovalOpinion"
                maxlength="30"
                size="mini"
                show-word-limit
              />
            </el-form-item>
          </span>
        </el-form>
      </div>
    </div>
    <div class="bill-box">
      <div class="bill-label"></div>
      <div class="btns">
        <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';
import ApplySample from '@/components/ApplySample';
export default {
  name: 'Bill',
  components: { DictSelect, ApplySample },
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listForm: [],
      saveLoading: false,
      rules: {
        leaderStatus: [
          { required: true, message: '请选择审批结果', trigger: 'change' },
        ],
        leadApprovalOpinion: [
          { required: true, message: '请输入理由', trigger: 'blur' },
        ],
      },
      expireTimeOption:  {  //验证时间范围
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  methods: {
    getListForm(arr) {
      this.listForm = arr.map(item => {
        return {
          ...item,
          list: item.list.map(item => ({
            ...item,
            leaderStatus: '',
            leadApprovalOpinion: ''
          }))
        }
      });
      this.clearConfirmInfoForm();
    },
    checkStatusChange(val, index) {
      // 清空数据
      const item = this.listForm[index].list[0];
      this.$set(item, 'leaderStatus', val);
      this.$set(item, 'leadApprovalOpinion', '');
      this.$refs.confirmInfoForm[index].clearValidate();
    },
    // 清空form表单
    clearConfirmInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.resetFields();
        });
      });
    },
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    save() {
      // form校验
      if (!this.checkFormValid()) {
        return;
      }
      const params = [ ...this.listForm ].reduce((prev, cur) => {
        prev.push(
          {
            ...cur.list[0]
          }
        );
        return prev;
      }, []);
      this.saveLoading = true;
      this.$http.sample
        .approvalOrderLead(params)
        .then(() => {
          this.$message.success('操作成功');
          this.removeTab('bill');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    cancelBtn() {
      this.removeTab('bill');
    }
  },
};
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
}
.bill-box {
  display: flex;
  padding: 10px;
  .product-info-box {
    position: relative;
    // height: 200px;
  }
  .bill-label {
    font-weight: bold;
    width: 190px;
  }
  .btns {
    width: 100%;
    margin-left: -180px;
    text-align: center;
  }
}
.outside-box {
  border-bottom: 1px dashed #ccc;
}
</style>
